export default "__VITE_PUBLIC_ASSET__2e0177b0__"